/**
 * Enumeration for the OptiDrive event exclusion model.
 *
 * @readonly
 * @enum {string}
 */
export const OptiDriveEventExclusionModel = Object.freeze({
    EVENT_ID: 'eventId',
    EVENT_TYPE: 'eventType',
    EXCLUSION_COMMENT: 'exclusionComment',
    EXCLUSION_REASON: 'exclusionReason',
    RECOVERY_COMMENT: 'recoveryComment'
})
